import axios from 'axios'
import { API_ENDPOINT } from '../../../../config'
import store from '../../../../redux/stores/store'
import Validation from '../../../../data/validation/validation'
import { DateValidationRule, StringValidationRule } from '../../../../data/validation/rules'
import { LoadJournals } from '../article.worker'
import { ScrollIntoViewById } from '../../../../utils/UIHelper'

const getAbstractText = (value) => {
    return (value || "")
        .replace(/<[^>]*>/g, " ")
        .replace(/&nbsp;/gi, " ")
        .replace(/&amp;/gi, "&")
        .replace(/\s+/g, " ")
        .trim()
}

const getContentText = (instance) => {
    return instance.state.contentType === "2"
        ? getAbstractText(instance.state.fullText)
        : getAbstractText(instance.state.abstract)
}

const getDefaultState = () => {
    return {
        updating: false,
        loadingJournals: false,
        loadingArticle: false,
        showUploadPdf: false,
        title: "",
        journalId: "",
        publicationDate: "",
        contentType: "1",
        abstract: "",
        fullText: "",
        keyAbstract: Math.random(),
        keyFullText: Math.random(),
        errors: {},
        journals: [],
        pdf: "",
        flag: {
            type: "",
            text: ""
        }
    }
}

const loadArticle = instance => {
    instance.setState({
        ...instance.state,
        loadingArticle: true
    })
    axios({
        method: 'post',
        url: API_ENDPOINT + "/api/article",
        headers: {
            "Authorization": store.getState().auth.authorization
        },
        data: {
            id: instance.props.match.params.id,
            Authorization: store.getState().auth.authorization
        }
    }).then(response => handleLoadArticleResponse(instance, response))
        .catch(error => alert(error))
}

const handleLoadArticleResponse = (instance, response) => {
    if (response.status !== 200) {
        return
    }
    switch (response.data.status) {
        case 200:
            instance.setState({
                ...instance.state,
                loadingArticle: false,
                title: response.data.data.article.title || "",
                journalId: response.data.data.article.journal ? response.data.data.article.journal.id : "",
                publicationDate: response.data.data.article.publicationDate || "",
                contentType: response.data.data.article.fullText ? "2" : "1",
                abstract: response.data.data.article.abstract || "",
                fullText: response.data.data.article.fullText || "",
                pdf: response.data.data.article.pdf || "",
                keyAbstract: Math.random(),
                keyFullText: Math.random(),
                flag: {
                    type: "",
                    text: ""
                }
            })
            break
        default:
            instance.setState({
                ...instance.state,
                loadingArticle: false,
                flag: {
                    type: "error",
                    text: response.data.message
                }
            })
    }
}

const updateArticle = (instance) => {
    instance.setState({
        ...instance.state,
        updating: true
    })
    axios({
        method: 'post',
        url: API_ENDPOINT + "/api/article/update",
        headers: {
            "Authorization": store.getState().auth.authorization
        },
        data: {
            Authorization: store.getState().auth.authorization,
            id: instance.props.match.params.id,
            title: instance.state.title,
            journalId: instance.state.journalId,
            publicationDate: instance.state.publicationDate,
            contentType: Number(instance.state.contentType),
            abstract: instance.state.abstract,
            fullText: instance.state.fullText,
        }
    }).then(response => handleUpdateArticleResponse(instance, response))
        .catch(error => {
            instance.setState({
                ...instance.state,
                updating: false
            })
            alert(error)
        })
}

const handleUpdateArticleResponse = (instance, response) => {
    if (response.status !== 200) {
        return
    }
    ScrollIntoViewById("editArticle")
    switch (response.data.status) {
        case 200:
            instance.setState({
                ...instance.state,
                updating: false,
                flag: {
                    type: "success",
                    text: "Article Updated"
                }
            })
            break
        default:
            instance.setState({
                ...instance.state,
                updating: false,
                flag: {
                    type: "error",
                    text: response.data.message
                }
            })
    }
}

const isValid = (instance) => {
    const validation = new Validation()
    const errors = {}

    validation.addValidationRule(StringValidationRule, instance.state.title, (error) => errors.title = error, { min: { value: 2, error: "Too short" }, max: { value: 650, error: "Too long" } })
    validation.addValidationRule(StringValidationRule, instance.state.journalId, (error) => errors.journalId = error, { min: { value: 20, error: "Too short" }, max: { value: 45, error: "Too long" } })
    validation.addValidationRule(DateValidationRule, instance.state.publicationDate, (error) => errors.publicationDate = error, { allowNull: false })

    if (instance.state.contentType === "2") {
        validation.addValidationRule(StringValidationRule, getContentText(instance), (error) => errors.fullText = error, { min: { value: 5, error: "Too short" }, max: { value: 9000000, error: "Too long" } })
    } else {
        validation.addValidationRule(StringValidationRule, getContentText(instance), (error) => errors.abstract = error, { min: { value: 5, error: "Too short" }, max: { value: 9000000, error: "Too long" } })
    }

    const validate = validation.validate()

    instance.setState({
        ...instance.state,
        errors: errors,
        flag: {
            type: validate ? "" : "error",
            text: validate ? "" : "Validation Failure"
        }
    })

    return validate
}

const showUploadPdf = (instance, shouldShow) => {
    instance.setState({
        ...instance.state,
        showUploadPdf: shouldShow
    })
}

const onPdfUploaded = (instance, pdf) => {
    instance.setState({
        ...instance.state,
        pdf: pdf
    })
}

const UpdateArticleWorker = instance => {
    return {
        getDefaultState: getDefaultState,
        isValid: () => isValid(instance),
        loadJournals: () => LoadJournals(instance),
        loadArticle: () => loadArticle(instance),
        updateArticle: () => updateArticle(instance),
        showUploadPdf: shouldShow => showUploadPdf(instance, shouldShow),
        onPdfUploaded: pdf => onPdfUploaded(instance, pdf)
    }
}

export default UpdateArticleWorker
